import { useState } from 'react'

const useIsOpen = (defaultValue = false) => {
  const [isOpen, setIsOpen] = useState(defaultValue)
  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)
  const toggle = () => setIsOpen(!isOpen)
  return { isOpen, open, close, toggle }
}

export default useIsOpen
